/* MIcase · comportamiento de la barra superior · externalizado de sections/micase-top-bar.liquid · 16 ago 2026
   La raiz ya no se busca por el id con section.id: se marca con data-mc-topbar en el HTML.
   Se carga con defer, asi que mide la barra con el DOM ya construido. */
(function () {
  var raiz = document.querySelector('[data-mc-topbar]');
  if (!raiz) return;

  /* 1. Altura de la barra, para que el encabezado pegajoso sepa donde empieza.
        En Glozin esto salia de un bloque javascript de Liquid y leia .section-top-bar. */
  function alto() {
    document.body.style.setProperty('--height-topbar', raiz.offsetHeight + 'px');
  }
  alto();
  if (window.ResizeObserver) { new ResizeObserver(alto).observe(raiz); }
  window.addEventListener('resize', alto);

  /* 2. Temporizador de la oferta. Colombia es UTC-05:00 todo el ano, sin horario de verano,
        asi que el desfase va fijo. Formato esperado: AAAA-MM-DD HH:MM */
  var conFin = raiz.querySelectorAll('[data-vence]');
  if (conFin.length) {
    conFin.forEach(function (el) {
      var v = (el.getAttribute('data-vence') || '').trim();
      var d = new Date(v.replace(' ', 'T') + ':00-05:00');
      el.mcFin = isNaN(d.getTime()) ? null : d.getTime();
      if (el.mcFin === null) {
        var t = el.querySelector('.mct-chip__timer');
        if (t) t.remove();
        el.hidden = false;
      }
    });

    var tick = function () {
      var vivos = 0;
      conFin.forEach(function (el) {
        if (el.mcFin === null) return;
        var falta = el.mcFin - Date.now();
        if (falta <= 0) { el.hidden = true; return; }
        el.hidden = false;
        vivos++;
        var reloj = el.querySelector('.mct-chip__t');
        if (!reloj) return;
        var seg = Math.floor(falta / 1000);
        var dias = Math.floor(seg / 86400);
        var hh = Math.floor((seg % 86400) / 3600);
        var mm = Math.floor((seg % 3600) / 60);
        var ss = seg % 60;
        var dos = function (n) { return (n < 10 ? '0' : '') + n; };
        reloj.textContent = (dias > 0 ? dias + 'd ' : '') + dos(hh) + ':' + dos(mm) + ':' + dos(ss);
      });
      if (vivos) setTimeout(tick, 1000);
    };
    tick();
  }

  /* 3. Copiar el codigo de descuento */
  raiz.querySelectorAll('.mct-chip--codigo').forEach(function (chip) {
    var copiar = function () {
      var cod = chip.getAttribute('data-codigo') || '';
      var etiqueta = chip.querySelector('.mct-chip__copiar');
      var hecho = function () {
        if (!etiqueta) return;
        etiqueta.textContent = chip.getAttribute('data-copiado') || 'COPIADO';
        setTimeout(function () { etiqueta.textContent = chip.getAttribute('data-copiar') || 'COPIAR'; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(cod).then(hecho, function () {});
      } else {
        var tmp = document.createElement('textarea');
        tmp.value = cod;
        document.body.appendChild(tmp);
        tmp.select();
        try { document.execCommand('copy'); hecho(); } catch (e) { console.warn('[MIcase] micase-top-bar: fallo al copiar el codigo de descuento al portapapeles con execCommand', e); }
        document.body.removeChild(tmp);
      }
    };
    chip.addEventListener('click', copiar);
    chip.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copiar(); }
    });
  });

  /* Preferencia del sistema de reducir el movimiento. Se consulta una vez y se reutiliza
     en la marquesina y en el deslizador. matchMedia no existe en navegadores muy viejos,
     de ahi la comprobacion. */
  var menosMovimiento = false;
  try {
    menosMovimiento = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch (e) {
    console.warn('[MIcase] micase-top-bar: no se pudo leer la preferencia de movimiento reducido', e);
  }

  /* 4. LA MARQUESINA, AHORA A SALTOS. Reescrita el 18 de agosto de 2026.

        POR QUE SE CAMBIO EL MECANISMO. Sebastian: "en iPad y en escritorio se queda
        quieta". Medido en Chromium con el codigo real, la barra NO se quedaba pegada por
        un fallo: lo unico que la dejaba muerta de forma permanente era "Reducir
        movimiento" del sistema, que es un ajuste POR DISPOSITIVO -de ahi que en el
        telefono fuera y en el iPad no-. La pausa al pasar el cursor si soltaba sola.

        Pero al medirlo salio algo peor que el sintoma. El bucle anterior movia scrollLeft
        en cada fotograma con requestAnimationFrame, y ese bucle NO PARABA NUNCA: seguia
        corriendo aunque la marquesina estuviera pausada. Diez segundos con la pagina
        quieta, escritorio 1440, metricas de Chromium:

            pagina sin la barra ........   1 ms de CPU
            marquesina anterior ........ 290 ms de CPU   (~2,9 % del hilo principal)
            este mecanismo .............  15 ms de CPU

        Casi 20 veces menos, en el elemento que esta en TODAS las paginas. No es
        una mejora de carga -no cambia ni un byte ni el LCP-: es bateria y fluidez.

        QUE NO CAMBIA, Y ES LA CONDICION QUE PUSO SEBASTIAN. La fila sigue siendo UNA sola
        linea de ancho libre. No se toca el maquetado: los chips conservan white-space
        nowrap y el grupo su width max-content, asi que NADA se puede partir en dos lineas
        por estrecha que sea la pantalla. Medido a 390 px: fila de 864 px, alto de 14 px,
        una sola linea, igual que antes. Lo unico que cambia es QUIEN la mueve.

        COMO SALTA. Cada N segundos avanza hasta el borde IZQUIERDO del siguiente chip que
        todavia no se ha visto, con una transicion de transform que hace el compositor.
        Ir al borde del chip -y no un ancho de pantalla- es lo que impide que la fila se
        detenga con un chip cortado por la mitad.

        EL RITMO ES EL MISMO. Antes una vuelta entera tardaba 21,6 s (864 px a 40 px/s).
        Con cuatro chips a 5 s por salto son 20 s. Se lee lo mismo, a la misma velocidad.

        MOVIMIENTO REDUCIDO: ya no la mata. Se quita la transicion, pero la fila sigue
        avanzando y aparece de golpe, igual que ya hacia el deslizador de mensajes de
        abajo. Quien pidio no ver cosas deslizandose no las ve; y la barra no queda muerta.

        AJUSTES (regla 46, todos desde el editor):
          data-cada  segundos entre saltos. 0 = quieta.
          data-trans milisegundos que dura el salto. 0 = instantaneo.
          data-siempre  moverse aunque el contenido quepa en la pista. */
  var caja = raiz.querySelector('.mct-chips');
  if (caja) {
    var pista = caja.querySelector('.mct-chips__track');
    var grupo = caja.querySelector('.mct-chips__set');
    var cada = parseFloat(caja.getAttribute('data-cada') || '0');
    if (!isFinite(cada) || cada < 0) cada = 0;
    var trans = parseFloat(caja.getAttribute('data-trans') || '600');
    if (!isFinite(trans) || trans < 0) trans = 0;
    if (menosMovimiento) trans = 0;
    /* 2026-08-11 · LA BARRA SE MUEVE AUNQUE EL CONTENIDO QUEPA.
       Al vencer la oferta se apagan el chip de promocion y el del codigo, la fila se
       acorta y en escritorio dejaria de moverse. Es una decision de diseno de Sebastian.
       El interruptor es el ajuste "Mover la barra aunque el contenido quepa". */
    var siempre = (caja.getAttribute('data-siempre') || '1') !== '0';
    if (pista && grupo && cada > 0) {
      /* 2026-08-19 · EL DESTELLO DE LA FILA ENTERA. Sebastian: "me aparece la marquesina de
         arriba y hace una micro carga donde se ve toda, luego si ya aparece difuminada a los
         laterales". Eran dos cosas. La primera: esto arrancaba en window.load, que espera a
         TODAS las imagenes y los iframes de la pagina, asi que hasta entonces la mascara valia
         --mct-foco:100% -su respaldo sin JavaScript- y se veian los cuatro chips a la vez. Ahora
         arranca con document.fonts.ready, que llega muchisimo antes y ademas garantiza que los
         anchos medidos son los definitivos: medir antes de que cargue la tipografia descentraria
         el foco. La segunda: aunque arranque pronto, sigue habiendo uno o dos fotogramas entre
         el pintado y la primera colocacion. La pista se esconde AQUI, sincrono, en cuanto el
         script diferido se ejecuta -antes del primer pintado- y se revela ya colocada.
         EL RESCATE NO ES OPCIONAL: si algo falla, la barra no puede quedarse invisible. Cada
         salida de arranca() revela, y ademas hay un temporizador de 1,5 s por si nunca se
         llegara a llamar. */
      var revelado = false;
      var revela = function () {
        if (revelado) return;
        revelado = true;
        clearTimeout(rescate);
        pista.style.transition = 'opacity 160ms ease';
        pista.style.opacity = '1';
      };
      pista.style.opacity = '0';
      var rescate = setTimeout(revela, 1500);
      var arranca = function () {
        var ancho = grupo.scrollWidth;
        if (!ancho) { revela(); return; }
        if (!siempre && ancho <= pista.clientWidth) { revela(); return; }
        /* EL CARRIL SE CREA AQUI, Y NO ES UN CAPRICHO.
           Lo que recorta la fila es el overflow de .mct-chips__track. Si el transform se
           le pone A LA PISTA, se mueve TAMBIEN su caja de recorte: los chips dejan de
           quedarse dentro de la barra y se salen por el lado. Medido: la fila entera
           acompanaba al desplazamiento y no se recortaba nada.
           Por eso el transform va en un carril INTERIOR, que se crea desde aqui para no
           tener que tocar el marcado de la seccion. La pista se queda quieta recortando y
           con su mascara; el carril es lo unico que se mueve. */
        if (!caja.mcClonado) {
          var carril = document.createElement('div');
          carril.className = 'mct-chips__rail';
          carril.style.display = 'flex';
          carril.style.width = 'max-content';
          carril.style.willChange = 'transform';
          pista.insertBefore(carril, grupo);
          carril.appendChild(grupo);
          grupo.style.flex = '0 0 auto';

          /* CUANTAS COPIAS. Al dar la vuelta se recoloca un grupo hacia atras, asi que a
             partir de ese punto lo que se ve tiene que ser identico: hace falta un grupo
             mas una pista entera. Se mide contra el ANCHO DE LA VENTANA y no contra el de
             la pista para que girar el iPad no obligue a volver a clonar: la pista nunca
             puede ser mas ancha que la ventana. */
          var tope = Math.max(pista.clientWidth, window.innerWidth || 0);
          /* +2 y no +1: al centrar el chip en foco hace falta contenido a la IZQUIERDA
             tambien, porque el recorrido arranca en el segundo grupo. */
          var copias = Math.ceil(tope / ancho) + 2;
          if (!isFinite(copias) || copias < 1) copias = 1;
          for (var c = 0; c < copias; c++) {
            var clon = grupo.cloneNode(true);
            clon.setAttribute('aria-hidden', 'true');
            /* Un contenedor con aria-hidden cuyos hijos siguen siendo enfocables es un
               fallo de accesibilidad: el lector no lo anuncia pero el tabulador entra
               igual. El clon es decorativo, asi que se le saca del recorrido. */
            clon.setAttribute('inert', '');
            clon.querySelectorAll('a, button, [tabindex], input, select, textarea').forEach(function (n) {
              n.setAttribute('tabindex', '-1');
              n.removeAttribute('role');
            });
            clon.classList.add('mct-chips__set--clon');
            clon.style.flex = '0 0 auto';
            carril.appendChild(clon);
          }
          caja.mcCarril = carril;
          caja.mcClonado = true;
        }
        var carril = caja.mcCarril;
        if (!carril) { revela(); return; }

        /* EL FOCO VA EN EL CENTRO. 2026-08-18, segunda vuelta de diseno con Sebastian:
           "el enfoque esta en todo... que quede justo en la mitad el que tenga toda la
           relevancia, y ya ahi, si desliza, ya tiene mas sentido".
           Antes cada salto dejaba el siguiente chip pegado al borde IZQUIERDO y los cuatro
           se leian a la vez, asi que el movimiento no dirigia la mirada a ninguna parte.
           Ahora el chip del turno se coloca en el CENTRO de la pista y se le pone la clase
           .is-foco; los demas se apagan por CSS. La mascara de los lados se encarga del
           resto. Un solo mensaje se lee cada vez, que era el objetivo.

           LOS PUNTOS DE PARADA SE MIDEN UNA SOLA VEZ: el borde izquierdo y el ancho de cada
           chip dentro de la pista. Se mide de antemano y no en cada salto para que el
           calculo no dependa de redondeos ni del relleno de 6 px del grupo. */
        var chipsTodos = pista.querySelectorAll('.mct-chip');
        var puntos = [], anchos = [];
        (function () {
          var base = pista.getBoundingClientRect().left;
          for (var i = 0; i < chipsTodos.length; i++) {
            var r = chipsTodos[i].getBoundingClientRect();
            puntos.push(r.left - base);
            anchos.push(r.width);
          }
        })();
        var porGrupo = grupo.querySelectorAll('.mct-chip').length;
        if (!puntos.length || !porGrupo || puntos.length < porGrupo * 2) { revela(); return; }

        /* El recorrido arranca en el SEGUNDO grupo para que al centrar el primer chip haya
           contenido a su izquierda y no se vea un hueco. El indice se mantiene siempre
           dentro de esa segunda vuelta. */
        var idx = porGrupo;
        var x = 0;
        var sobre = false;          /* el cursor esta encima */
        var pausaHasta = 0;

        function centroDe(i) {
          return (pista.clientWidth - anchos[i]) / 2 - puntos[i];
        }

        function marcaFoco() {
          for (var i = 0; i < chipsTodos.length; i++) {
            if (i === idx) chipsTodos[i].classList.add('is-foco');
            else chipsTodos[i].classList.remove('is-foco');
          }
        }

        /* LA VENTANA SE AJUSTA AL TEXTO, NO AL REVES. 2026-08-18, Sebastian:
           "el 30 % es mucho o poco, eso dependera de que tan largo sea el texto... que
           simplemente muestre el texto y, de acuerdo a eso, oculte lo demas".
           Tenia razon y era un fallo, no una preferencia: con una banda fija -30 % a 70 %-
           un chip mas largo que ese hueco se difuminaba a si mismo por los extremos. Ahora
           el JavaScript publica el ancho del chip en foco en --mct-foco y la mascara abre
           exactamente ese hueco, sea cual sea el texto. Los 12 px de mas son aire para que
           la letra no muera justo en el borde del degradado. */
        function coloca(conTransicion) {
          x = centroDe(idx);
          pista.style.setProperty('--mct-foco', (anchos[idx] + 12) + 'px');
          carril.style.transition = conTransicion && trans > 0 ? ('transform ' + trans + 'ms ease') : 'none';
          carril.style.transform = 'translateX(' + x + 'px)';
          marcaFoco();
        }

        /* Al salir de la segunda vuelta se retrocede un grupo entero SIN transicion. Como
           los clones son identicos, lo que se ve es exactamente lo mismo: el ojo no lo nota. */
        function reencaja() {
          if (idx < porGrupo * 2) return;
          idx -= porGrupo;
          carril.style.transition = 'none';
          carril.style.transform = 'translateX(' + centroDe(idx) + 'px)';
          x = centroDe(idx);
          pista.style.setProperty('--mct-foco', (anchos[idx] + 12) + 'px');
          marcaFoco();
          void carril.offsetWidth;   /* fuerza el reflujo: si no, se come la transicion siguiente */
        }
        carril.addEventListener('transitionend', reencaja);

        function paso() {
          if (document.hidden || sobre || Date.now() < pausaHasta) return;
          if (idx + 1 >= puntos.length) return;   /* no deberia pasar: hay clones de sobra */
          idx += 1;
          coloca(true);
          if (trans <= 0) reencaja();     /* sin transicion no hay transitionend */
        }

        coloca(false);                    /* primera colocacion, ya centrada y con foco */
        revela();                         /* ya esta enmascarada y centrada: ahora si se ve */
        setInterval(paso, cada * 1000);

        /* Al cambiar el ancho -girar el iPad, redimensionar- el centro es otro. Se recoloca
           sin transicion; no hace falta volver a clonar porque las copias se calcularon
           contra el ancho de la ventana. */
        var tRe = null;
        window.addEventListener('resize', function () {
          clearTimeout(tRe);
          tRe = setTimeout(function () { coloca(false); }, 150);
        });

        /* La pausa cuesta una comprobacion cada N segundos, no una por fotograma. Se
           mantiene porque si alguien se para a leer un chip, que no se le mueva.
           Solo con raton o lapiz: en tactil un mouseenter sintetico dejaria la barra
           congelada despues de tocarla. */
        pista.addEventListener('pointerenter', function (ev) {
          if (ev.pointerType === 'touch') return;
          sobre = true;
        });
        pista.addEventListener('pointerleave', function () { sobre = false; });
        pista.addEventListener('pointerdown', function () { pausaHasta = Date.now() + 8000; });
        pista.addEventListener('focusin', function () { pausaHasta = Date.now() + 12000; });
      };
      if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
        document.fonts.ready.then(arranca).catch(arranca);
      } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', arranca);
      } else { arranca(); }
    }
  }

  /* 5. Deslizador de tres mensajes, sin Swiper.
        Su ritmo es un ajuste aparte del bloque (Cambiar cada N segundos); no es la
        velocidad de la marquesina. Tambien se para al pasar el cursor por encima. */
  raiz.querySelectorAll('.mct-slider').forEach(function (sl) {
    var items = sl.querySelectorAll('.mct-slider__it');
    if (items.length < 2) return;
    var cada = (parseFloat(sl.getAttribute('data-cada')) || 4) * 1000;
    if (cada < 1000) cada = 1000;
    var i = 0;
    var encima = false;
    sl.addEventListener('pointerenter', function (ev) {
      if (ev.pointerType === 'touch') return;
      encima = true;
    });
    sl.addEventListener('pointerleave', function () { encima = false; });
    setInterval(function () {
      if (encima || document.hidden) return;
      items[i].removeAttribute('data-activa');
      i = (i + 1) % items.length;
      items[i].setAttribute('data-activa', '');
    }, cada);
  });
})();
